<template>
  <div class="guestTagRecharge">
    <div class="flex justify-space-between align-center">
      <h2 class="title"></h2>
      <router-link to="/" class="link">
        <span @click="clearRechargeFormState">&lt; Regresar</span>
      </router-link>
    </div>
    <div class="card flex dspl-block-sm">
      <section class="card-section grow-1">
        <div class="flex justify-space-between dspl-block-m dspl-block-sm">
          <h3>Recarga de TAG para Carril Ordinario Vehicular</h3>
        </div>
        <div class="flex justify-center dspl-block-m dspl-block-sm">
          <img src="@/assets/images/tag.png">
        </div>
        <GuestTagForm />
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GuestTagForm from '@/components/Recharge/GuestTagForm'

export default {
  name: 'GuestTagRecharge',
  components: {
    GuestTagForm
  },
  methods: {
    ...mapActions('rechargeTagForm', [
      'clearRechargeFormState'
    ])
  }
}
</script>

<style scoped lang="scss">
.guestTagRecharge {
  padding: 2rem;
}
img {
  max-width: 40%;
}
@media screen and (max-width: 960px) {
  img {
    max-width: 80%;
  }
}
</style>
